






// @ is an alias to /src
import {Component, Mixins} from "vue-property-decorator";
import PropertyEdit from "@/components/property/propertyEdit.vue";
import PropertyDetail from "@/components/property/propertyDetail.vue";
import Authority from "@/common/mixins/authority";

@Component({
  name: "PropertyListPage",
  components: {
    PropertyEdit,
    PropertyDetail,
  },
})
export default class PropertyEditPage extends Mixins(Authority) {
  get currentComponent() {
    if (
      ["admin.property-edit", "admin.property-create"].includes(
        this.$route.name
      )
    ) {
      return "PropertyEdit";
    } else {
      return "PropertyDetail";
    }
  }
}
